export const STRIPE_JS_SDK_URL = 'https://js.stripe.com';

export const SUPPORTED_LANGS = [
  'auto',
  'da',
  'de',
  'en',
  'es',
  'es-419',
  'fi',
  'fr',
  'it',
  'ja',
  'nb',
  'nl',
  'pl',
  'pt',
  'sv',
  'zh',
];

export const SUPPORTED_SUBMIT_TYPES = [
  'auto',
  'book',
  'donate',
  'pay',
];

export const BILLING_ADDRESS_COLLECTION_TYPES = [
  'required',
  'auto',
];

export const SHIPPING_ADDRESS_COLLECTION_UNSUPPORTED_COUNTRIES = [
  'AS',
  'CX',
  'CC',
  'CU',
  'HM',
  'IR',
  'KP',
  'MH',
  'FM',
  'NF',
  'MP',
  'PW',
  'SD',
  'SY',
  'UM',
  'VI',
];

export const NOTIFICATIONS = {
  PRODUCT_ADDED: (isOrderApprovalEnabled) => ({
    color: 'success',
    title: isOrderApprovalEnabled ? 'Product added to Inventory Request': 'Product added',
    text: isOrderApprovalEnabled
      ? 'Product successfully added'
      : 'Product was successfully added to your cart.',
  }),
  PRODUCT_INCREMENT: (isOrderApprovalEnabled) => ({
    color: 'success',
    title: isOrderApprovalEnabled ? 'Product quantity increased in your Inventory Request' : 'Product added to your cart',
    text: isOrderApprovalEnabled
      ? 'Product quantity successfully increased'
      : 'Product successfully added to your cart.',
  }),
  PRODUCT_DECREMENT: (isOrderApprovalEnabled) => ({
    color: 'success',
    title: isOrderApprovalEnabled ? 'Product quantity decreased in your Inventory Request' : 'Product removed from your cart',
    text: isOrderApprovalEnabled
      ? 'Product quantity successfully decreased'
      : 'Product was successfully removed from your cart.',
  }),
  PRODUCT_REMOVED: (isOrderApprovalEnabled) => ({
    color: 'warning',
    title: 'Product removed',
    text: isOrderApprovalEnabled
      ? 'Product was successfully removed from your cart and approval has been revoked.'
      : 'Product was successfully removed from your cart.',
  }),
  PRODUCT_NOT_UPDATED: (isOrderApprovalEnabled) => ({
    color: 'danger',
    title: 'Product Not Updated',
    text: `We are having issues updating your ${isOrderApprovalEnabled ? 'Inventory Request':'cart'}. Please try again.`,
  }),
};

export const CART = {
  CART_STATUS_TEXT: (isOrderApprovalEnabled) => ({
    text: isOrderApprovalEnabled
      ? 'in your Inventory Forecast'
      : 'in your cart',
  }),
  CART_EMPTY_TEXT: (isOrderApprovalEnabled) => ({
    text: isOrderApprovalEnabled ? 'Your Inventory Forecast Is Empty.' : 'Your Cart Is Empty.',
  }),
};

export const INVENTORY_TEXT = {
  'Shop': 'Inventory Forecast',
  'Products': 'Inventory Forecast',
  'My Orders': 'Clinic Orders',
};
